import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const BreadcrumbNavContainer = styled('nav', {
  base: {
    paddingTop: '14px',
    paddingBottom: '12px',
    minHeight: '36px',
  },
});

export const BreadcrumbNavOrderedList = styled('ol', {
  base: {
    display: 'flex',
    listStyle: 'none',
    lineHeight: '2',
    alignItems: 'baseline',
  },
});

export const ListItem = styled('li', {
  base: {
    fontSize: 'sm',
    lineHeight: 'sm',

    '&:not(:last-of-type)::after': {
      display: 'inline-block',
      marginTop: '0',
      marginBottom: '0',
      marginLeft: '8px',
      marginRight: '8px',
      transform: 'rotate(15deg)',
      borderRightWidth: '1px',
      borderRightStyle: 'solid',
      borderRightColor: 'hpxGrey600',
      height: '10px',
      content: '""',
    },
  },
});

// CSS class for the Linker component since we can't directly style an imported component
export const breadcrumbLinkerClass = css({
  _focus: {
    outlineWidth: '1px',
    outlineStyle: 'auto',
    outlineColor: '-webkit-focus-ring-color',
    outlineOffset: '3px',
  },
});
